import { Injectable } from '@angular/core';
import * as Mnemonic from 'bitcore-mnemonic';
import * as util from 'ethereumjs-util';
import * as hdkey from 'ethereumjs-wallet/hdkey';
import * as bip39 from 'bip39';
import { Storage } from '@ionic/storage';

import { StorageService } from './storage.service';

const prop = '__wps';
const show = 'show_alert';

@Injectable()
export class WalletService {
  private address;
  private privateKey;
  private mnemonic;
  private publicKey;

  constructor(public storageService: StorageService, private storage: Storage) {
    this.storageService.has(prop).then(val => {
      if (!val) {
        console.log(' wallet Service !val', val);
        this.storage.set(show, true);
        this.storageService.set(prop, new Mnemonic().phrase).then(val => {
          console.log('set val ', val);
          this.initializeWallet();
        });
      } else {
        this.initializeWallet();
      }
    });
  }

  async initializeWallet() {
    // Get new or existing pk
    console.log('Entrando en initializwWallet');
    var path = "m/44'/60'/0'/0/0";
    this.mnemonic = new Mnemonic(await this.storageService.get(prop));
    console.log('initializaWallet mnemonic ', this.mnemonic);
    let wallet = hdkey
      .fromMasterSeed(bip39.mnemonicToSeed(this.getMnemonic()))
      .derivePath(path)
      .getWallet();

    this.privateKey = wallet.getPrivateKey();
    this.publicKey = util.privateToPublic(this.privateKey);
    this.address = '0x' + util.pubToAddress(this.publicKey).toString('hex');
    return true;
  }

  async updateSeeds(seeds: string) {
    await this.storageService.set(prop, seeds);
    return this.initializeWallet();
  }

  getAddress() {
    return this.address;
  }

  getMnemonic() {
    return this.mnemonic.toString();
  }

  getPrivateKey() {
    return this.privateKey;
  }

  async generateNewSeeds() {
    await this.storageService.set(prop, new Mnemonic().phrase);
    this.initializeWallet();
  }

  setShowAlert(showAlert: boolean) {
    this.storage.set(show, showAlert);
  }

  getShowAlert() {
    return this.storage.get(show);
  }
}



// WEBPACK FOOTER //
// ./src/services/wallet.service.ts